import { ia, mString } from 'lib/helpers/utility';
import { flipDentalPercent } from 'lib/constants/billing/dentalCategories';

import DrAvatar from './lib/components/DrAvatar';
import InfoCallout from './lib/components/InfoCallout';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const DentalCoveragePage = ({ estimate }) => {
  const services = estimate?.services || [];
  const remainingDeductible = estimate?.remainingDeductible ?? null;
  const annualMaxRemaining = estimate?.annualMaxRemaining ?? null;

  // Only surface services the payer actually reported a coverage percentage for.
  const covered = services.filter((service) => service.coveragePercent != null);

  return (
    <div className="flex flex-col gap-5">
      <SlideHeader title="Your balance" />

      <div className="flex items-end gap-4">
        <DrAvatar size="medium" variant={3} className="shrink-0" />
        <SpeechBubble variant="highlight" tail="left">
          Dental plans share cost a little differently — instead of one rate, you pay a set
          percentage of each type of service, and your plan covers the rest up to its yearly
          maximum.
        </SpeechBubble>
      </div>

      {ia(covered) && (
        <div className="overflow-hidden rounded-xl border border-solid border-neutral-200 shadow-sm">
          <div className="bg-neutral-50 px-4 py-2">
            <p className="text-sm font-600 uppercase tracking-wider text-neutral-500">
              What you pay
            </p>
          </div>
          <div className="flex flex-col divide-y divide-neutral-50">
            {covered.map((service, index) => (
              <div
                key={`${service.service_id ?? service.code ?? 'service'}-${index}`}
                className="flex items-center justify-between gap-3 px-4 py-2.5">
                <span className="text-sm text-neutral-600">
                  {service.name || service.code || 'Service'}
                </span>
                <span className="text-sm font-600 text-primary-900">
                  {flipDentalPercent(service.coveragePercent)}%
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="flex gap-3 sm:flex-col">
        <div className="flex-1 rounded-xl border border-solid border-neutral-200 bg-white p-4">
          <p className="text-sm font-500 uppercase text-neutral-500">Remaining Deductible</p>
          <p className="text-lg font-700 text-primary-900">
            {remainingDeductible != null ? mString(remainingDeductible) : '—'}
          </p>
        </div>
        <div className="flex-1 rounded-xl border border-solid border-neutral-200 bg-white p-4">
          <p className="text-sm font-500 uppercase text-neutral-500">Annual Max Remaining</p>
          <p className="text-lg font-700 text-primary-900">
            {annualMaxRemaining != null ? mString(annualMaxRemaining) : '—'}
          </p>
        </div>
      </div>

      <InfoCallout />
    </div>
  );
};

export default DentalCoveragePage;
